<template>
  <div>
    <v-row>
      <v-col>
        {{
          isAT
            ? "Grupos de iniciativas"
            : isGov
            ? "Grupos de Fases"
            : "Grupos de soluções"
        }}
        desabilitados
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="solutionsGroup"
          item-key="name"
          class="elevation-1"
        >
          <template v-slot:item.acoes="{ item }">
            <AppModalRecoverGroup
              @onRecover="onRecoverM"
              :payload="{
                nomeGrupo: item.nome,
                municipioid: item.municipioId,
                municipiogruposolucaoid: item.municipioGrupoSolucaoId,
              }"
            >
            </AppModalRecoverGroup>
          </template>
          <template slot="no-data">
            <div>
              Não há
              {{
                isAT
                  ? "Grupos de iniciativas"
                  : isGov
                  ? "Grupos de Fases"
                  : "Grupos de soluções"
              }}
              desabilitados
            </div>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import AppModalRecoverGroup from "../ModalRecoverGroup";

export default {
  name: "AppRetrieveGroupSolution",
  props: {
    solutionsGroup: { type: Array, required: true },
  },
  components: {
    AppModalRecoverGroup,
  },
  data() {
    return {
      headers: [
        {
          text: "Nome",
          align: "left",
          value: "nome",
        },
        {
          text: "Descricao",
          value: "descricao",
        },
        { text: "Habilitar", value: "acoes", sortable: false },
      ],
    };
  },
  computed: {
    ...mapGetters(["loading", "isAT", "isGov"]),
  },
  methods: {
    ...mapActions(["setLoading"]),
    onRecoverM() {
      this.$emit("onRecover");
    },
  },
  mounted() {},
};
</script>
